import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { UserHistoryEventType } from '../_types/user-history-event-type';

@Injectable({
    providedIn: 'root'
})
export class UserHistoryEventTypesService extends Service<UserHistoryEventType> {
    public override type = 'userHistoryEventTypes';
    public override url = 'auth/userHistoryEventTypes';
}
